package com.qrkontaq.ui.sections.header.components

import androidx.compose.runtime.Composable
import com.qrkontaq.ui.utils.Constants

@Composable
internal fun MenuItems(onItemClick: (() -> Unit)? = null) {
    NavLink(Constants.SECTION_HOME, "Home", onItemClick)
    NavLink(Constants.SECTION_ABOUT, "About", onItemClick)
    NavLink(Constants.SECTION_SERVICES, "Services", onItemClick)
    NavLink(Constants.SECTION_PROJECTS, "Projects", onItemClick)
    NavLink(Constants.SECTION_CONTACTS, "Contacts", onItemClick)
}
